export function defineCssVars(vars, target = document.querySelector('#app')) {
  Object.entries(vars).forEach(([key, value]) => target.style.setProperty(key, value));
}
